import React from "react";
import { BrowserRouter as Router, Route, Routes, NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Dashboard from "./pages/Dashboard.js";
import AssetRegister from "./pages/AssetRegister.js";
import PreventiveMaintenance from "./pages/PreventiveMaintenance.js";
import WorkOrders from "./pages/WorkOrders";
import Inventory from "./pages/Inventory.js";
import ComplianceReports from "./pages/ComplianceReports.js";

// Firebase setup
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBkggqnDfsXCJARRT-GT7H7SsXOObr52zU",
  authDomain: "boda-maintenance.firebaseapp.com",
  projectId: "boda-maintenance",
  storageBucket: "boda-maintenance.firebasestorage.app",
  messagingSenderId: "345095788322",
  appId: "1:345095788322:web:b02c37b7bb9e09279e377b"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

function App() {
  return (
    <Router>
      <div className="d-flex">
        {/* Sidebar */}
        <div className="bg-dark text-light vh-100 p-3" style={{ width: "250px" }}>
        <img
        className="rounded mx-auto d-block"
          src="https://rean.co.in/static/media/only-logo.4d63700e101039d58fb7.png"
          alt="ChatGPT Logo"
          style={{ width: "100px", height: "90px", marginBottom:'20px'}}
        />
        <h4>WTP Maintenance</h4>
          <nav className="nav flex-column">
            <NavLink className="nav-link text-light" to="/">Dashboard</NavLink>
            <NavLink className="nav-link text-light" to="/asset-register">Asset Register</NavLink>
            <NavLink className="nav-link text-light" to="/preventive-maintenance">Preventive Maintenance</NavLink>
            <NavLink className="nav-link text-light" to="/work-orders">Work Orders</NavLink>
            <NavLink className="nav-link text-light" to="/inventory">Inventory & Spare Parts</NavLink>
            <NavLink className="nav-link text-light" to="/compliance-reports">Compliance Reports</NavLink>
          </nav>
        </div>

        {/* Main Content */}
        <div className="flex-grow-1 p-4">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/asset-register" element={<AssetRegister />} />
            <Route path="/preventive-maintenance" element={<PreventiveMaintenance />} />
            <Route path="/work-orders" element={<WorkOrders />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/compliance-reports" element={<ComplianceReports />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
